import axios from 'axios';

const CLIENT_ID = (() => {
  let id = localStorage.getItem('lgd_client_id');
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem('lgd_client_id', id);
  }
  return id;
})();

axios.interceptors.request.use((config) => {
  config.params = config.params || {};
  if (!config.params.client_id) {
    config.params.client_id = CLIENT_ID;
  }
  return config;
});
